import { load } from 'poly-eshop4/eshop/ui/js/util';

const check = /^([^:]+):(.*)$/;
$(window).bind('message', (event) => {
  if (event.originalEvent.origin === 'https://webscan.popscan.com') {
    event.stopPropagation();
    event.stopImmediatePropagation();
    event.preventDefault();

    const r = check.exec(event.originalEvent.data);

    if (r) {
      if (r[1] !== 'scan') {
        return false;
      }

      const scan = JSON.parse(r[2]);
      const $form = $('#container-popscan');

      const codes = [];
      scan.codes.forEach((code) => {
        if (code.startsWith('$pcn')) {
          if (!codes.length) {
            return;
          }
          const quantity = parseInt(code.substr(4), 10);
          if (quantity) {
            codes[codes.length - 1].quantity += quantity;
          }
        } else {
          codes.push({
            id: code,
            quantity: 0,
          });
        }
      });

      $form.find('[data-container-import-data]').val(codes.map(code => `${code.id};${code.quantity || 1}`).join('\n'));

      load(
        $form,
        $.stores.cart.post($form.attr('action'), new FormData($form[0])),
      ).then((result) => {
        const $reveal = $('#container-import').removeClass('error');
        const $data = $reveal.find('[data-container-import-data]');
        const $msg = $reveal.find('[data-cart-import-messages]').html('').hide().removeClass('alert');
        if (result.has_errors === true) {
          $form.closest('[data-reveal]').foundation('close');
          $reveal.foundation('open');
          $reveal.addClass('error');
          $msg.addClass('alert');
          if ($data.length && result.errors) {
            $data.val(result.errors);
          }
        } else {
          $form.foundation('close');
        }
        $msg.html(result.import_messages)[result.import_messages ? 'show' : 'hide']();
        [$('#container-popscan iframe')[0].src] = $('#container-popscan iframe')[0].src.split('#');
      });
    }
  }

  return true;
});
